// extracted by mini-css-extract-plugin
export default {"device-image-container":"device-image-container__HWVE3"};